<template>
  <section class="admin-content" id="contact-search">
    <div class="page-header">
      <div class="container">
        <div class="row p-b-60 p-t-60">
          <div class="col-md-6 text-center mx-auto text-white p-b-30">
            <div class="m-b-10">
              <div class="header-icon-wrap mx-auto">
                <i class="fe fe-user-plus" style="font-size: 22px;"></i>
              </div>
            </div>
            <p class="h4">
              <strong>Self Enrollment Form</strong>
            </p>
          </div>
        </div>
      </div>
    </div>

    <main class="admin-main">
      <section class="container mt-n3 pb-5">
        <div class="">
          <div class="row list">
            <div class="col-lg-12 col-md-12">
              <div class="card table-card m-b-30 shadow">
                <div class="form-card-header">
                  <div class="section-number"><i class="fe fe-file-text" style="font-size:13px;"></i></div>
                  <div>
                    <p class="mb-0 text-white font-weight-bold" style="font-size:.95rem;">Enrollee Details</p>
                    <small style="color:rgba(255,255,255,.7);">
                      All fields marked with <span class="text-warning">*</span> are compulsory
                    </small>
                  </div>
                </div>
                <div class="card-body">
                  <form @submit.prevent="submitForm">
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label class="info-label d-block mb-1" for="inputPassword4"
                          >Last Name <span class="text-danger">*</span></label
                        >
                        <input
                          type="text"
                          class="form-control"
                          required
                          v-model="register.lastname"
                          placeholder="Last Name"
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label class="info-label d-block mb-1" for="inputEmail4"
                          >First Name <span class="text-danger">*</span></label
                        >
                        <input
                          type="text"
                          class="form-control"
                          required
                          v-model="register.firstname"
                          placeholder="First Name"
                        />
                      </div>

                      <div class="form-group col-md-6">
                        <label class="info-label d-block mb-1" for="inputPassword4">Middle Name</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="register.middlename"
                          placeholder="Last Name"
                        />
                      </div>

                      <div class="form-group col-md-6">
                        <label class="info-label d-block mb-1" for="inputEmail4">NIN Number</label>
                        <input
                          type="text"
                          inputmode="numeric"
                          pattern="\d*"
                          maxlength="11"
                          class="form-control"
                          v-model="register.nimc_number"
                          @input="register.nimc_number = register.nimc_number.replace(/\D/g, '').slice(0, 11)"
                          placeholder="NIN Number"
                        />
                      </div>

                      <div class="form-group col-md-6">
                        <label class="info-label d-block mb-1" for="inputPassword4">Date of Birth: </label>
                        <input
                          type="date"
                          required
                          class="form-control"
                          v-model="register.dob"
                          placeholder="DD/MM/YYYY"
                        />
                      </div>

                      <div class="form-group col-md-6">
                        <label class="info-label d-block mb-1">Select Group </label>

                        <select
                          class="form-control"
                          v-model="register.place_of_work"
                        >
                          <option
                            v-for="mda in mdas"
                            :key="mda.name"
                            :value="mda.id"
                          >
                            {{ mda.name }}
                          </option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label class="info-label d-block mb-1" for="inputEmail4"
                          >Email </label
                        >
                        <input
                          type="email"
                          class="form-control"
                          v-model="register.email"
                          placeholder="Email"
                        />
                      </div>

                      <div class="form-group col-md-6">
                        <label class="info-label d-block mb-1" for="inputPassword4"
                          >Phone Number
                          <span class="text-danger">*</span></label
                        >
                        <input v-phone
                          type="tel"
                          class="form-control"
                          required
                          v-model="register.phone_number"
                          placeholder="Phone Number"
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label class="info-label d-block mb-1" for="inputCity"
                          >Gender <span class="text-danger">*</span></label
                        >
                        <select
                          class="form-control"
                          required
                          v-model="register.gender"
                        >
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label class="info-label d-block mb-1"
                          >Marital Status
                          <span class="text-danger">*</span></label
                        >
                        <select
                          class="form-control"
                          required
                          v-model="register.marital_status"
                        >
                          <option value="Married">Married</option>
                          <option value="Widow">Widow</option>
                          <option value="Single">Single</option>
                          <option value="Separated">Separated</option>
                          <option value="Divorced">Divorced</option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label class="info-label d-block mb-1">LGA <span class="text-danger">*</span></label>
                        <select
                          class="form-control"
                          required
                          v-model="register.localgovt"
                          @change="fetchWards($event)"
                        >
                          <option
                            v-for="lga in lga_states"
                            v-bind:key="lga"
                            :value="lga.id"
                          >
                            {{ lga.local_name }}
                          </option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label class="info-label d-block mb-1">Ward</label>
                        <select
                          class="form-control"
                          v-model="register.ward"
                          @change="getProvidersByWards($event)"
                        >
                          <option
                            v-for="ward in wards"
                            v-bind:key="ward.id"
                            :value="ward.id"
                          >
                            {{ ward.ward_name }}
                          </option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label class="info-label d-block mb-1">Facility for Accessing Health Care </label>
                        <v-select
                          v-model="register.provider_id"
                          required
                          :options="providers"
                          label="agency_name"
                          :value="register.provider_id"
                          @input="selected"
                        ></v-select>
                      </div>

                      <div class="form-group col-md-6">
                        <label class="info-label d-block mb-1" for="inputCity">Blood Group</label>
                        <select class="form-control" v-model="register.blood">
                          <option value="NA">NA</option>
                          <option value="A+">A+</option>
                          <option value="A-">A-</option>
                          <option value="B+">B+</option>
                          <option value="B-">B-</option>
                          <option value="AB+">AB+</option>
                          <option value="AB-">AB-</option>
                          <option value="O+">O+</option>
                          <option value="O-">O-</option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label class="info-label d-block mb-1" for="inputAddress">Home Address</label>
                        <input
                          required
                          type="text"
                          class="form-control"
                          v-model="register.address"
                          placeholder="1234 Main St"
                        />
                      </div>

                      <div class="form-group col-md-6">
                        <label class="info-label d-block mb-1" for="inputCity"> Select Agent</label>
                        <select
                          class="form-control"
                          v-model="register.enrolled_by"
                        >
                          <option
                            :value="emoployee.id"
                            v-for="emoployee in employees.data"
                            v-bind:key="emoployee.id"
                          >
                            {{ emoployee.firstname }} {{ emoployee.lastname }}
                          </option>
                        </select>
                      </div>

                      <div class="form-group col-md-12">
                        <label class="info-label d-block mb-1">Enrollee Photo <span class="text-danger">*</span></label>
                        <button class="btn btn-outline-info" type="button" @click="takePicAndroid">
                          Capture Photo <i class="fe fe-camera"></i>
                        </button>
                      </div>

                      <div class="form-group col-md-6" v-if="register.user_image">
                        <img
                          :src="register.user_image"
                          class="rounded img-fluid"
                          style="max-width:160px;"
                          alt="Enrollee Photo"
                          onerror="this.onerror=null; this.src='/assets/img/kgshia_logo.png'"
                        />
                      </div>
                    </div>

                    <div class="col-md-12 mt-4">
                      <p class="h5">Our Services Include:</p>

                      <button
                        type="button"
                        @click="selectSuggestion(rev)"
                        v-for="rev in services"
                        :key="rev"
                        class="btn m-b-15 mx-2 badge badge-soft-dark"
                      >
                        {{ rev }}
                      </button>
                    </div>

                    <div>
                      <p class="mb-2">
                        <strong>
                          Declaration & warranty on behalf of all persons
                          proposed to be insured</strong
                        >
                      </p>

                      <ul class="declaration-list">
                        <li>
                          I/We hereby declare, on my behalf and on behalf of
                          all persons proposed to be insured that the above
                          statements, answers and/or particulars given by me
                          are true and complete in all respects to the best of
                          my knowledge and that I/We am/ are authorized to
                          propose on behalf of these other persons.
                        </li>
                        <li>
                          I understand that the information provided by me
                          will form the basis of insurance policy, is subject
                          to the Board approved underwriting policy of KGSHIA
                          and that the policy will come into force only after
                          full receipt of the premium chargeable.
                        </li>
                        <li>
                          I/ We further declare that I/We will notify in
                          writing any change occurring in the occupation or
                          general health of the life to be insured/ proposer
                          after the proposal has been submitted but before
                          communication of the risk acceptance by KGSHIA.
                        </li>
                        <li>
                          I/We declare and consent to KGSHIA seeking medical
                          information from any hospital who at any time has
                          attended on the life to be insured/ proposer or from
                          any past or present employer concerning anything
                          which affects the physical and mental health of the
                          life to be assured/proposer and seeking information
                          from any insurance company to which an application
                          for insurance on the life to be assured/ proposer
                          has been made for the purpose of underwriting the
                          proposal and/or claim settlement.
                        </li>
                        <li>
                          I/ We authorize KGSHIA to share information
                          pertaining to my proposal including the medical
                          records for the sole purpose of proposal
                          underwriting and/or claims settlement and with any
                          Governmental and/or Regulatory Authority.
                        </li>
                      </ul>

                      <div class="form-group">
                        <div class="form-check">
                          <input
                            required
                            class="form-check-input"
                            type="checkbox"
                            id="declarationAccept"
                            v-model="declarationAccepted"
                          />
                          <label class="form-check-label" for="declarationAccept">
                            I/We have read, understood and accept all of the
                            declarations above
                            <span class="text-danger">*</span>
                          </label>
                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <button class="btn btn-submit btn-block btn-lg">
                        Submit <i class="fe fe-send"></i>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div class="vld-parent">
              <loading
                :active.sync="isLoading"
                loader="dots"
                :can-cancel="true"
                :is-full-page="fullPage"
              ></loading>
            </div>
          </div>
        </div>
      </section>
    </main>
  </section>
</template>

<script>
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";

export default {
  components: {
    Loading,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      services: [
        "Dental Care",
        "Surgery",
        "General Consultation",
        "Ante-natal Care",
        "Deliveries",
        "Post-natal Care",
        "Ear Nose & Throat Care",
        "Eye Care",
        "Emergency Care",
        "X-ray",
        "Ultrasound",
        "Laboratory",
        "Orthopaedic",
        "Physiotherapy",
        "Skincare",
        "Mental Care",
        "Internal Medicine",
        "Child Healthcare",
      ],
      employees: "",
      states: "",
      show: false,
      clients: "",
      providers: "",
      sector: "informal",
      mdas: "",
      wards: "",
      tpas: "",
      providers_wards: "",
      state: "",
      OfficerDetails: "",
      current_page: "",
      selected_provider: "",
      selected_provider_dependents: "",
      image: "",
      imagefile: null,
      lga_states: "",
      response: "",
      declarationAccepted: false,
      register: {
        user_image: "",
        firstname: "",
        lastname: "",
        middlename: "",
        nimc_number: "",
        email: "",
        phone_number: "",
        type: "client",
        agency_id: "",
        state: "",
        localgovt: "",
        ward: "",
        address: "",
        blood: "",
        weight: "",
        gender: "",
        genotype: "",
        dob: "",
        enrolled_by: "",
        expiry_date: new Date(),
        salary_number: "",
        provider_id: "",
        point_of_care: "",
        sector: "Voluntary Contributor",
        finger_print: "",
        place_of_work: "",
        plan_type: "Individual",
        org_id: "",
        grade_level: "",
        date_of_entry: "",
        marital_status: "",
        category_of_vulnerable_group: "",
      },
    };
  },
  beforeMount() {
    //
  },
  computed: {
    addYear() {
      var d = new Date();
      var year = d.getFullYear();
      var month = d.getMonth();
      var day = d.getDate();
      var c = new Date(year + 1, month, day);
      // var c = new Date(year + 1);
      console.log(c);
      return c;
    },
  },

  methods: {
    selected(value) {
      this.selected_provider = value.id;
    },
    selectedPointocare(value) {
      this.selected_provider_dependents = value.agency_name;
    },
    submitForm() {
      const snap = localStorage.getItem("voluntary_snap");
      if (!this.register.user_image && !snap) {
        this.$toasted.error(`Enrollee photo is required`, {
          position: "top-center",
          duration: 3000,
        });
        return;
      }
      if (!this.declarationAccepted) {
        this.$toasted.error(`You must accept the declaration to continue`, {
          position: "top-center",
          duration: 3000,
        });
        return;
      }
      if (confirm("Are you sure you want to submit?")) {
        this.registerUserAdmin();
      }
    },

    fetchWards() {
      this.axios
        .get(`/api/v1/auth/getwards/${event.target.value}`)
        .then((response) => {
          this.wards = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    fetchLga() {
      this.axios
        .get(`/api/v1/auth/lga/2669`)
        .then((response) => {
          this.lga_states = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    registerUserAdmin() {
      this.isLoading = true;
      let snap = localStorage.getItem("voluntary_snap");

      this.axios
        .post("/api/v1/auth/register", {
          nimc_number: this.register.nimc_number,
          firstname: this.register.firstname.toUpperCase(),
          lastname: this.register.lastname.toUpperCase(),
          middlename: this.register.middlename.toUpperCase(),
          email: this.register.email,
          plan_type: this.register.plan_type,
          phone_number: this.register.phone_number,
          type: this.register.type,
          sectorType: this.sector,
          user_image: this.register.user_image || snap,
          agency_id: 90,
          provider_id: this.selected_provider
            ? this.selected_provider
            : this.register.provider_id,
          state: "2669",
          role: 0,
          password: "jacobi",
          localgovt: this.register.localgovt,
          ward: this.register.ward,
          blood: this.register.blood,
          dob: this.register.dob,
          address1: this.register.address,
          genotype: this.register.genotype,
          weight: this.register.weight,
          gender: this.register.gender,
          sector: this.register.sector,
          place_of_work: this.register.place_of_work,
          enrolled_by: this.register.enrolled_by,
          point_of_care: this.selected_provider
            ? this.selected_provider
            : this.register.provider_id,
          finger_print: this.register.finger_print,
          salary_number: this.register.salary_number,
          grade_level: this.register.grade_level,
          date_of_entry: this.register.date_of_entry,
          marital_status: this.register.marital_status,
          category_of_vulnerable_group:
            this.register.category_of_vulnerable_group,
        })
        .then((response) => {
          console.log(response);
          this.isLoading = false;
          this.$toasted.info("Submited Successfully!", {
            position: "top-center",
            duration: 8000,
          });
          let user_id = response.data.data.id;

          this.$router.push(`/subscribe/${user_id}`);
        })
        .catch((error) => {
          console.log(error.response);
          this.isLoading = false;
          this.response = error.response.data.errors;
          this.$toasted.error(`${JSON.stringify(this.response)}`, {
            position: "top-center",
            duration: 3000,
          });
        });
    },

    getProviders() {
      this.axios
        .get(`/api/v1/auth/providerAgency/90`)
        .then((response) => {
          this.providers = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    getProvidersByWards() {
      this.axios
        .get(
          `/api/v1/auth/providerAgencies/90/${this.register.localgovt}/${this.register.ward}`
        )
        .then((response) => {
          this.providers_wards = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getEmployees() {
      this.axios
        .get(`/api/v1/auth/getEmployee/90`, {
          params: {
            job_title: "marketer",
          },
        })
        .then((response) => {
          this.employees = response.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getMDAs() {
      this.axios
        .get(`/api/v1/auth/ministries/90`, {
          params: {
            type: "private",
          },
        })
        .then((response) => {
          this.mdas = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async takePicAndroid() {
      try {
        const image = await Camera.getPhoto({
          quality: 90,
          allowEditing: false,
          resultType: CameraResultType.Base64,
          source: CameraSource.Camera,
        });

        this.register.user_image = `data:image/png;base64,${image.base64String}`;
        this.$toasted.info("Image taken Successfully!", {
          position: "top-center",
          duration: 8000,
        });
      } catch (error) {
        console.error(error);
        this.$toasted.error("Could not access camera.", {
          position: "top-center",
          duration: 3000,
        });
      }
    },
  },
  created() {
    this.getMDAs();
    this.fetchLga();
    this.getProviders();
    this.getEmployees();
  },
};
</script>

<style scoped>
/* ── Design-system classes (kgshia has no global design-system.css yet,
     so these are inlined locally to match claimify's shared admin theme) ── */
.page-header {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  padding-bottom: 60px;
}
.header-icon-wrap {
  width: 52px; height: 52px;
  background: rgba(255, 255, 255, 0.18);
  border-radius: 14px;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.container.mt-n3 { margin-top: -32px !important; }
.table-card { border-radius: 14px !important; border: none !important; overflow: hidden; }
.form-card-header {
  display: flex; align-items: center; gap: 12px;
  padding: 16px 24px;
  background: linear-gradient(135deg, #1e3a5f, #2563eb);
}
.section-number {
  width: 28px; height: 28px; border-radius: 50%;
  background: rgba(255, 255, 255, 0.25); color: #fff;
  font-size: 13px; font-weight: 700;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.info-label {
  font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.05em;
  color: #94a3b8; margin-bottom: 1px; font-weight: 600;
}
.btn-submit {
  background: linear-gradient(135deg, #2563eb, #7c3aed) !important;
  color: #fff !important; border: none !important; border-radius: 8px !important;
  font-weight: 600 !important; transition: opacity 0.15s;
}
.btn-submit:hover, .btn-submit:focus { opacity: 0.9; color: #fff !important; }
.declaration-list { padding-left: 1.2rem; font-size: 0.9rem; color: #475569; }
.declaration-list li { margin-bottom: 8px; }
</style>
